import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axiosProtected from "../config/baseWithToken";
import { getTransactions } from "../transaction";
import { getNotifications } from "../notification";

export const addWallet = createAsyncThunk(
  "store/add-wallet",
  async (balance, {dispatch, rejectWithValue}) => {
    try {
      let { data } = await axiosProtected.post("/store/wallets", balance);
      toast.success(data.message);
      dispatch(getWallet())
      dispatch(getTransactions({page:0, size:5}))
      dispatch(getNotifications({page:0, size:50}))
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const getWallet = createAsyncThunk(
  "store/get-wallet",
  async (wallet, thunkAPI) => {
    try {
      const { data } = await axiosProtected.get(`/store/wallets/balance`);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
